import React from "react";

import { DocumentDesktop as StyledDocumentDesktop } from "./DocumentDesktop.styles.js";
import { formatCpf, formatCnpj } from "../../../utils/formatter";

import Loading from "../../../components/Loading";

const DocumentDesktop = ({
	loading,
	document,
	submit,
	onClickSignatureBox,
	documentTextMarkup
}) => {
	if (loading || !document) {
		return <Loading />;
	}

	return (
		<StyledDocumentDesktop>
			<StyledDocumentDesktop.Term>
				<StyledDocumentDesktop.TermContainer>
					<StyledDocumentDesktop.TermTextContainer>
						<StyledDocumentDesktop.TermTitle>
							{document.title}
						</StyledDocumentDesktop.TermTitle>

						<StyledDocumentDesktop.TermText style={{ maxHeight: '325px', marginTop: '16px', overflowY: 'scroll' }}>
							<span dangerouslySetInnerHTML={documentTextMarkup()}></span>
						</StyledDocumentDesktop.TermText>
					</StyledDocumentDesktop.TermTextContainer>

						<StyledDocumentDesktop.FooterSignature onClick={onClickSignatureBox} hasSignature={!!document?.signature_url}>
							{document?.signature_url ? (
								<StyledDocumentDesktop.FooterSignature.Image src={document.signature_url} />
							) : (
								<StyledDocumentDesktop.FooterSignature.Placeholder>Clique aqui para assinar o documento</StyledDocumentDesktop.FooterSignature.Placeholder>
							)}
							</StyledDocumentDesktop.FooterSignature>

						<StyledDocumentDesktop.TermFooter>

						<StyledDocumentDesktop.UserContainer>
							<StyledDocumentDesktop.UserName>
								{document?.destinatary?.name}
							</StyledDocumentDesktop.UserName>
							<StyledDocumentDesktop.Cpf>
								{document?.destinatary?.cpf ? formatCpf(document?.destinatary?.cpf) : formatCnpj(document?.destinatary?.cnpj)}
							</StyledDocumentDesktop.Cpf>
						</StyledDocumentDesktop.UserContainer>
					</StyledDocumentDesktop.TermFooter>
				</StyledDocumentDesktop.TermContainer>
			</StyledDocumentDesktop.Term>

			<StyledDocumentDesktop.Signature>
				<StyledDocumentDesktop.SignatureContainer>
					<StyledDocumentDesktop.SignatureCenter>
						<StyledDocumentDesktop.SignatureTitle>
						{document?.company?.name} <span style={{ fontWeight: '400' }}>enviou um documento para você assinar.</span>
						</StyledDocumentDesktop.SignatureTitle>
					</StyledDocumentDesktop.SignatureCenter>
					<StyledDocumentDesktop.SignatureCenter>
						<StyledDocumentDesktop.Button className="af-button af-button--primary" disabled={!document?.signature_url} marginTop={16} type="primary" onClick={submit}>
							<StyledDocumentDesktop.ButtonText>
								Assinar e concluir
							</StyledDocumentDesktop.ButtonText>
						</StyledDocumentDesktop.Button>
					</StyledDocumentDesktop.SignatureCenter>
					<StyledDocumentDesktop.SignatureCenter>
						<StyledDocumentDesktop.SignatureText>
							Para concluir o processo de assinatura é necessário inserir as informações solicitadas e clicar no botão "Assinar e Concluir"
						</StyledDocumentDesktop.SignatureText>
					</StyledDocumentDesktop.SignatureCenter>
				</StyledDocumentDesktop.SignatureContainer>
			</StyledDocumentDesktop.Signature>
		</StyledDocumentDesktop>
	);
};

export default DocumentDesktop;
